.Writer {
    display: block;
    // border: 1px solid #ccc;
    height: 20vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .wrapper {
        width: 100%;
    }
    .textareaContainer {
        border-bottom: 2px solid #ccc;

        .textarea {
            padding: 20px;

            &.hasPlaceholder {
                color: #999;
            }
        }
    }

    button {
        float: right;
        border: 1px solid #ccc;
        background-color: #fff;
        padding: 5px 10px;
        font-size: 11px;
        margin-top: 20px;
        color: #666;
    }
}
